import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
  }>()
  .create(({ isLayoutMobile, theme }) => {
    return {
      caseTitle: {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      caseSubTopbarTop: {
        backgroundColor: theme.vars.palette.background.elevation1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        zIndex: 2
      },
      topContent: {
        boxShadow: isLayoutMobile ? theme.shadows[2] : 'none',
        display: 'flex',
        flexDirection: isLayoutMobile ? 'column' : 'row',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        width: '100%'
      },
      topContentOrganizationName: {
        display: 'inline',
        fontSize: '1rem',
        fontWeight: 'normal'
      },
      priorityBadge: {
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
        color: theme.vars.palette.common.white,
        display: 'flex',
        fontSize: '1.5rem',
        fontWeight: 700,
        height: '3rem',
        justifyContent: 'center',
        width: '3rem',
        minHeight: '3rem',
        minWidth: '3rem'
      }
    };
  });

export default useStyles;
